<template>
  <div style="width: 100%">
    <div class="form__input">
      <input
        @click.prevent="openPopup()"
        type="text" readonly
        v-model="input"
      >
      <span>{{data.name}}</span>
      <div v-if="data.edit || data.edit == undefined">
        <a class="form__close date" v-if="input" @click.prevent="clear"></a>
      </div>
    </div>
    <Popup v-if="popup.fade" :popup="popup" :dateInput="input" @ReadyDate="ReadyDateOn" @close="popup.fade = !popup.fade" />
  </div>
</template>


<style lang="scss">
  .form__close.date{
    right: -5px;
  }
</style>



<script>
import Popup from '@/components/app/Popup'


export default {
  props: ['data'],

  data: () => ({
    popup: {fade: false, mod: 'Date', title: 'Дата', date: '', min: '', modTime: ''},
    input: '',
    date1: '',
    date2: '',
  }),

  watch:{
    data: function(){
      if(this.data.data == '0000-00-00 00:00:00' || this.data.data == null || this.data.data == '0000-00-00' || this.data.data == ''){
        this.input = ''
      } else{
        if(this.data.mod == 'is-range'){

        }else if(this.data.mod){
          this.input = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(this.data.data))+ 
          '  в  ' + new Date(this.data.data).toLocaleTimeString().slice(0,-3)
          this.popup.date = this.data.data
        } else{
          if(this.data.data.search('-') != -1){
            this.input = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(this.data.data.replace(/-/g, "/")))
            this.popup.date = this.data.data
            this.$emit('resultData', {date: this.input, input: this.data.input})
          }
        }
      }
    }
  },

  created() {
    if(this.data.mod){
      this.popup.modTime = this.data.mod
    }
    if(this.data.data == '0000-00-00 00:00:00' || this.data.data == null || this.data.data == '0000-00-00' || this.data.data == ''){
      this.input = ''
    } else{
      if(this.data.mod == 'is-range'){
        this.date1 = this.data.data.split('-')[0];
        this.date2 = this.data.data.split('-')[1];
        this.input = this.data.data;
        this.$emit('resultData', {date: this.input, input: this.data.input})
      }else if(this.data.mod){
        this.input = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(this.data.data.replace(/-/g, "/")))
        + '  в  ' + new Date(this.data.data).toLocaleTimeString().slice(0,-3)
        this.popup.date = this.data.data
        this.$emit('resultData', {date: new Date(this.data.data), input: this.data.input})
      } else{
        if(new Date(this.data.data.replace(/-/g, "/")) != 'Invalid Date'){
          this.input = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(this.data.data.replace(/-/g, "/")))
          this.popup.date = this.data.data
        } else{
          this.input = this.data.data;
        }
        this.$emit('resultData', {date: this.input, input: this.data.input})
      }
    }
  },


  methods: {
    //dataPopup
    ReadyDateOn(data){
      if(data[0].date !== null){
        if(this.data.mod == 'is-range'){
          if(data[0].date.start !== undefined){
            this.date1 = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "2-digit"}).format(new Date(data[0].date.start));
            this.date2 = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "2-digit"}).format(new Date(data[0].date.end));
            this.input = this.date1 + '-' + this.date2;
            this.$emit('resultData', {date: this.input, input: this.data.input});
          }
        } else{
          this.input = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(data[0].date))
          if(this.data.mod){
            this.input += '  в  ' + new Date(data[0].date).toLocaleTimeString().slice(0,-3)
            this.$emit('resultData', {date: data[0].date, input: this.data.input})
          } else{
            this.$emit('resultData', {date: this.input, input: this.data.input})
          }
        }
      }
    },
    openPopup(){
      function date(date) {
        if (date) {
          var year = date.substr(6, 2);
          var day = date.substr(0, 2);
          var month = date.substr(3, 2);
          var resultDate =
            new Date('20' + year + "-" + month + "-" + day);
          return resultDate;
        }
      }
      if(this.data.edit || this.data.edit == undefined){
        if(this.data.mod == 'is-range'){
          this.popup.date = {start: date(this.date1), end: date(this.date2)};
        } else{
          this.popup.date = this.data.data
        }
        if(this.data.min){
          if(this.data.min == '0000-00-00 00:00:00' || this.data.min == '0000-00-00'){
          } else{
            this.popup.min = this.data.min
            this.popup.fade = !this.popup.fade
          }
        } else if(this.data.min == undefined && this.data.min !== null){
          this.popup.fade = !this.popup.fade
        } else{
        }
      }
    },
    clear(){
      this.input = ''
      this.$emit('resultData', {date: this.input, input: this.data.input})
    }
  },



  components: {
    Popup
  }
}
</script>